export class ValidationHelper {
  static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
    const config = {
      required: 'Required',
      invalidCreditCard: 'Is invalid credit card number',
      invalidEmailAddress: 'Invalid email address',
      invalidPassword: 'Invalid password. Password must be at least 6 characters long, and contain a number.',
      invalidUrl: 'URL use http:// or https://',
      minlength: `Minimum length ${validatorValue.requiredLength}`,
      maxlength: `Maximal length ${validatorValue.requiredLength}`,
      invalidPhone: 'Phone format: plus(+) country_code phone_number',
      invalidNumber: 'This field can only be filled with numbers',
      invalidIpAddress: 'IP Address format is xxx.xxx.xxx.xxx',
      invalidLeadNotes: 'Notes should contain at least 10 characters',
      invalidText:"spaces not allowed",
      invalidWhiteSpace:"spaces not allowed"
    };

    return config[validatorName];
  }

  static creditCardValidator(control) {
    // Visa, MasterCard, American Express, Diners Club, Discover, JCB
    const regex = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/
    if (control.value.match(regex)) {
      return null;
    } else {
      return { invalidCreditCard: true };
    }
  }

  static emailValidator(control) {
    // RFC 2822 compliant regex
    const regex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
    if (control.value && control.value.match(regex)) {
      return null;
    } else {
      return { invalidEmailAddress: true };
    }
  }

  static passwordValidator(control) {
    // {6,100}           - Assert password is between 6 and 100 characters
    // (?=.*[0-9])       - Assert a string has at least one number
    const regex = /^.*(?=.{8,})(?=.*[a-zA-Z])(?=.*\d)(?=.*[!#$%&? "]).*$/
    if (control.value.match(regex)) {
      return null;
    } else {
      return { invalidPassword: true };
    }
  }

  static urlValidatorNotRequired(control) {
    if (control.value == null || control.value === '') {
      return null;
    }
    const regex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
    if (control.value && control.value.match(regex)) {
      return null;
    } else {
      return { invalidUrl: true };
    }
  }
  static urlValidator(control) {
    const regex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
    if (control.value && control.value.match(regex)) {
      return null;
    } else {
      return { invalidUrl: true };
    }
  }
  static phoneValidator(control) {
    const regex = /^\+\d+$/;
    if(control.value && control.value.match(regex)) {
      return null;
    } else {
      return { invalidPhone: true }
    }
  }
  static numberValidator(control) {
    const regex = /^\d+$/;
    if(control.value && control.value.match(regex)) {
      return null;
    } else {
      return { invalidNumber: true }
    }
  }

  static ipAddressValidatorNotRequired(control) {
    if (control.value == null || control.value === '') {
      return null;
    }
    const regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    if(control.value && control.value.match(regex)) {
      return null;
    } else {
      return { invalidIpAddress: true }
    }
  }

  static leadNotesValidator(control) {
    const regex = /^.{10,}$/;
    if(control.value && control.value.match(regex)) {
      return null;
    } else {
      return { invalidLeadNotes: true };
    }
  }
   static trimTrim(control) {
    const regex = /^[^\s]+(\s+[^\s]+)*/;
     if(control.value && control.value.match(regex)) {
      return null;
    } else {
      return {invalidText:true};
    }
   }
   static noWhiteSpaces(control) {
    const regex = /^\S*$/;
     if(control.value && control.value.match(regex)) {
      return null;
    } else {
      return {invalidWhiteSpace:true};
    }
   }
}
